import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {
  submitAgentBranchDocument,
  updateAgentBranchDocument
} from "../../services/agent_branch_document/agent_branch_document";
import SelectInput from "../system/select";
import {getAgentBranchFieldAndBranchTitles} from "../../services/agent/agent_branch";
import {getBranchDocumentsByBranchId} from "../../services/branch_document/branch_document";

export function AgentBranchDocumentForm({AgentBranchDocument, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [branchDocumentId, setBranchDocumentId] = useState(AgentBranchDocument?.id ?? null)


  const [id, setId] = useState(AgentBranchDocument?.id ?? null)
  const [branchId, setBranchId] = useState(AgentBranchDocument?.branch_id ?? null)
  const [title, setTitle] = useState(AgentBranchDocument?.title ?? "")
  const [description, setDescription] = useState(AgentBranchDocument?.description ?? "");
  const [status, setStatus] = useState(AgentBranchDocument && AgentBranchDocument.status && AgentBranchDocument.status === 'enable' ? true : false)

  useEffect(() => {
    setId((AgentBranchDocument && AgentBranchDocument.id) || null);
    setTitle((AgentBranchDocument && AgentBranchDocument.branch_id) || null);
    setTitle((AgentBranchDocument && AgentBranchDocument.title) || "");
    setDescription((AgentBranchDocument && AgentBranchDocument.description) || "");
    setStatus(AgentBranchDocument && AgentBranchDocument.status && AgentBranchDocument.status === 'enable' ? true : false);
  }, [AgentBranchDocument]);

  const save = async () => {
    const data = {
      id: id,
      branch_id: branchId,
      title: title,
      description: description,
      status: status ? "enable" : "disable"
    };

    let result;

    if (!id) {
      result = await submitAgentBranchDocument(data);
    } else {
      result = await updateAgentBranchDocument(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <SelectInput
              label={"گرایش"}
              defaultValue={branchId}
              autoLoadService={getAgentBranchFieldAndBranchTitles}
              autoLoadRender={({field_title, branch_title}) => {
                return field_title + " - " + branch_title
              }}
              onChange={setBranchId}
            />
          </div>

          <div className="mb-4">
            <SelectInput
              label={Dict("branch_document_recommended")}
              defaultValue={branchDocumentId}
              autoLoadService={getBranchDocumentsByBranchId}
              autoLoadServiceData={branchId}
              refreshSignal={branchId}
              autoLoadRender={({title, description}) => {
                return title + " - " + description
              }}
              onChange={setBranchDocumentId}
              title={true}
              setTitle={setTitle}
              description={true}
              setDescription={setDescription}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={description}
                   label={Dict('description')}
                   placeholder={Dict('description')}
                   onChange={(e) => {
                     setDescription(e.target.value)
                   }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}